/* unplugin-vue-components disabled */import { render } from "./BatchUpdateUser.vue?vue&type=template&id=bb8ae24e&scoped=true&ts=true"
import script from "./BatchUpdateUser.vue?vue&type=script&lang=ts"
export * from "./BatchUpdateUser.vue?vue&type=script&lang=ts"

import "./BatchUpdateUser.vue?vue&type=style&index=0&id=bb8ae24e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8ae24e"]])

export default __exports__